import defaultEnterPlu from './assets/enterPlu.png';
import defaultLogoBlack from './assets/logoBlack.svg';
import defaultLogoCompany from './assets/logoCompany.png';
import defaultLogoWhite from './assets/logoWhite.svg';
import { resolveBrandPalette } from './resolveBrand';
import { Brand } from '@whiz-cart/node-shared/models/brand/brand';

export const defaultBrand = {
    _id: 'whizcart',
    palette: resolveBrandPalette({
        primary: {
            main: '#666666',
            light: '#c9c9c9',
            dark: '#474747',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#666666',
            light: '#848484',
            dark: '#474747',
            contrastText: '#ffffff',
        },
        discount: {
            main: '#d30c2a',
            contrastText: '#ffffff',
        },
        free: {
            main: '#68bee0',
            contrastText: '#ffffff',
        },
        cartBackground: {
            main: '#000000',
            light: '#333333',
            dark: '#000000',
            contrastText: '#ffffff',
        },
        navigationBackground: {
            main: '#313335',
            light: '#5a5b5d',
            dark: '#222325',
            contrastText: '#ffffff',
        },
        disruptor: {
            main: '#fdd764',
            contrastText: '#ffffff',
        },
        mapNewProduct: {
            main: '#ef8820',
            contrastText: '#ffffff',
        },
        mapBoughtInPast: {
            main: '#54276c',
            contrastText: '#ffffff',
        },
    }),
    images: {
        logoBlack: defaultLogoBlack,
        logoWhite: defaultLogoWhite,
        logoColor: defaultLogoBlack,
        logoCompany: defaultLogoCompany,
        cartBackground: null,
        enterPlu: defaultEnterPlu,
    },
    icons: {},
    customIcons: {},
    customerIds: [],
    borderRadius: 15,
    cartBrand: 'Whizcart',
    cartBrandShort: 'Whizcart',
    headerDisplayTotal: false,
    headerUsePrimaryColor: false,
    priceLayoutAlt: false,
    promotionsLayoutAlt: false,
    highlightAddToBasket: false,
    cartUiTutorialSlides: [],
    emails: {
        images: {
            logoEmailLightMode: defaultLogoBlack,
            logoEmailDarkMode: defaultLogoWhite,
        },
    },
} as const satisfies Brand;
